var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-circular',{staticClass:"d-print-none",style:(_vm.style),attrs:{"size":_vm.size,"indeterminate":"","color":_vm.color}})
}
var staticRenderFns = []

export { render, staticRenderFns }